export default __webpack_public_path__ + "static/media/closet1-480w.4d090668.webp";